export const SET_REFERENTIAL = 'AccessibilityReferentialForm/SET_REFERENTIAL'
